import * as lendiaConfig from "./CustomThemeLendia";
import * as finbeConfig from "./CustomThemeFinbe";
import * as finbraConfig from "./CustomThemeFinbra";
import * as nowPortsConfig from "./CustomThemeNowPorts";
import * as marketPlaceConfig from "./CustomThemeMarketPlace";
import * as avanzaSolidoConfig from "./CustomThemeAvanzaSolido";
import * as kapitalFlexConfig from "./CustomThemeKapitalFlex";
import * as providenciConfig from "./CustomThemeProvidencia";
import * as kalapataConfig from "./CustomThemeKalapata";
import * as sfiConfig from "./CustomThemeSFI";

export const DEFAULT_THEME = finbeConfig;

export const THEMES = {
  lendia: lendiaConfig,
  finbe: finbeConfig,
  finbra: finbraConfig,
  now_ports: nowPortsConfig,
  market_place: marketPlaceConfig,
  avanza_solido: avanzaSolidoConfig,
  kapital_flex: kapitalFlexConfig,
  providencia: providenciConfig,
  kalapata: kalapataConfig,
  sfi: sfiConfig,
};
